import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Vous pouvez créer ce fichier pour des styles globaux si nécessaire
import App from './App'; // Importe votre composant App.js

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Si vous voulez commencer à mesurer la performance dans votre application, passez une fonction
// pour journaliser les résultats (par exemple: reportWebVitals(console.log))
// ou envoyez à un point de terminaison d'analyse. En savoir plus: https://bit.ly/CRA-vitals
